export default __webpack_public_path__ + "media/images/features/ana/Collaborate_Otetsutabi-94bc13eacdee34cbb633be3396ff99a7.png";